// Photo de facture prise au téléphone : on compresse avant l'envoi à l'OCR
// (les clichés bruts font 3 à 8 Mo et saturent la base partagée).
export async function compresserFichier(file, maxPx = 1600, qualite = 0.72) {
  const dataUrl = await compresserImage(file, maxPx, qualite);
  const binaire = atob(dataUrl.split(',')[1]);
  const octets = new Uint8Array(binaire.length);
  for (let i = 0; i < binaire.length; i += 1) octets[i] = binaire.charCodeAt(i);
  const nom = file.name.replace(/\.[^.]+$/, '') || 'scan';
  return { fichier: new File([octets], `${nom}.jpg`, { type: 'image/jpeg' }), dataUrl };
}

// Réduit et encode une image en data URL pour le stockage local (justificatifs).
export function compresserImage(file, maxPx = 1000, qualite = 0.6) {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('image/')) {
      reject(new Error('Formats acceptés : JPG, PNG, WEBP ou HEIC.'));
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      reject(new Error('Fichier trop volumineux (10 Mo maximum).'));
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Lecture du fichier impossible.'));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error('Image illisible.'));
      img.onload = () => {
        const ratio = Math.min(1, maxPx / Math.max(img.width, img.height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(img.width * ratio);
        canvas.height = Math.round(img.height * ratio);
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL('image/jpeg', qualite));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}
